import { type ColumnDef } from "@tanstack/react-table"
import type { ISearchItem } from "@commonTypes/searchResponse"
import { LinkCell } from "@utils/table/columnFactories"
import { Contact, User } from "lucide-react"

export const accountsColumns: ColumnDef<ISearchItem>[] = [
  {
    id: "actions",
    cell: ({ row }) => {
      const account = row.original
      return (
        <LinkCell
          to={`/profiles/${account.membership_profile_id}/accounts/${account.account_id}`}
        >
          <User />
          <span>Details</span>
        </LinkCell>
      )
    },
  },
  {
    header: "ID",
    accessorKey: "account_id",
  },
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Service Address",
    accessorKey: "service_address",
  },
  {
    header: "Account Identifier",
    accessorKey: "account_number",
  },
  {
    header: "Phone",
    accessorKey: "primary_phone",
  },
]

export const prospectsColumns: ColumnDef<ISearchItem>[] = [
  {
    id: "actions",
    cell: ({ row }) => {
      const prospect = row.original
      return (
        <LinkCell to={`/prospect/${prospect.prospect_guid}`}>
          <Contact />
          <span>Details</span>
        </LinkCell>
      )
    },
  },
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Service Address",
    accessorKey: "service_address",
  },
  {
    header: "Phone",
    accessorKey: "primary_phone",
  },
]
